import { render, staticRenderFns } from "./ToolbarComponent.vue?vue&type=template&id=27530e1c&"
import script from "./ToolbarComponent.vue?vue&type=script&lang=js&"
export * from "./ToolbarComponent.vue?vue&type=script&lang=js&"
import style0 from "./ToolbarComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports